import React from 'react';
import { observer } from 'mobx-react-lite';
import { RouteConfig } from 'routes/index';
import { enrollmentRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { useRootStore } from 'store/rootStore';
import { Switch } from 'react-router-dom';
import RoleBasedRoute from 'routes/RoleBasedRoute';
import AddEmployeesPage from 'pages/enrollment/add-employees/AddEmployees';
import CensusUploadPage from 'pages/enrollment/add-employees/CensusUploadPage';
import CensusReviewPage from 'pages/enrollment/add-employees/CensusReviewPage';

const routes: RouteConfig[] = [
  {
    path: '/add-employees/census-upload/:groupId/:periodId',
    component: CensusUploadPage,
    roleCheck: enrollmentRights,
  },
  {
    path: '/add-employees/census-review/:groupId/:periodId',
    component: CensusReviewPage,
    roleCheck: enrollmentRights,
  },
  {
    path: '/add-employees/:groupId/:periodId',
    component: AddEmployeesPage,
    roleCheck: enrollmentRights,
  },
];

const LocalRouter: React.FC = observer(() => {
  const {
    userStore: { userRoles },
  } = useRootStore();

  const convertedUserRoles = userRoles.slice();
  return (
    <Switch>
      {routes.map((route) => (
        <RoleBasedRoute exact key={route.path} userRoles={convertedUserRoles} {...route} />
      ))}
    </Switch>
  );
});

export const AddEmployeesFlow: React.FC = () => {
  return <LocalRouter />;
};
